import { Routes } from './routes.tsx';
import '../index.css';

function App() {
  return (
    <div className="min-h-screen bg-gray-50 w-full">
      <Routes />
    </div>
  );
}

export default App; 